import { useTheme } from "@rentiohq/web-shared-next/dist/themes";

export const ContractMetaStyles = () => {
  const theme = useTheme();

  return {
    content: {
      propertyTitle: {
        cursor: "pointer",
        color: theme.palette.success.main,
      },
    },
  };
};
